import React from "react";
import HomeIcon from '@mui/icons-material/Home';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PersonIcon from '@mui/icons-material/Person';
import PunchClockIcon from '@mui/icons-material/PunchClock';

export interface MenuItemType {
  icon: React.ReactChild,
  title: string,
  items: string[any]
}
export const menuNavigation = [
  {
    icon: <DashboardIcon />,
    title: "Dashboard",
    items: [
      
    ]
  },
  /* {
    icon: <PersonIcon />,
    title: "People"
  },
  {
    icon: <PunchClockIcon />,
    title: "Shifts"
  } */
];